import { forwardRef } from "react";
import { Gift } from "lucide-react";

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { timeZone: "Europe/Rome" }) : "");

/** Card grafica Gift Card con fiocco (usata per anteprima, download e stampa). */
export const GiftCardVisual = forwardRef(function GiftCardVisual({ card, compact = false }, ref) {
  const what = card.kind === "product"
    ? card.product_name || "Il tuo prodotto"
    : `€ ${Number(card.value_eur || 0).toFixed(2)} di credito`;
  return (
    <div ref={ref} data-testid="gift-card-visual"
      className="relative w-full max-w-[560px] aspect-[1.6/1] rounded-[28px] overflow-hidden shadow-2xl text-[#3b2a33] select-none"
      style={{ background: "linear-gradient(135deg, #f6e9ef 0%, #ecd3df 55%, #dcbccd 100%)" }}>
      {/* nastri */}
      <div className="absolute inset-y-0 left-[22%] w-7 bg-[#b47a96]/80" />
      <div className="absolute top-[38%] left-0 w-[36%] h-7 bg-[#b47a96]/80" />
      {/* fiocco */}
      <div className="absolute left-[22%] top-[38%] -translate-x-[38%] -translate-y-[42%] w-20 h-20 rounded-full bg-[#9c5f7e] shadow-lg flex items-center justify-center ring-4 ring-[#f6e9ef]">
        <Gift className="w-10 h-10 text-white" strokeWidth={1.4} />
      </div>
      <div className={`absolute inset-0 pl-[36%] flex flex-col ${compact ? "pr-4 py-4" : "pr-6 py-6"}`}>
        <div className="text-[10px] uppercase tracking-[0.35em] text-[#7d5068]">Epic Flow Pilates · Gift Card</div>
        <div className={`font-serif-display italic mt-2 leading-tight ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}>
          Per {card.recipient_name || "te"}
        </div>
        <div className={`font-serif-display mt-1 leading-snug ${compact ? "text-base" : "text-lg sm:text-xl"}`} data-testid="gift-card-what">{what}</div>
        {card.include_annual && <div className="text-[10px] uppercase tracking-widest mt-0.5">iscrizione annuale inclusa</div>}
        {card.message && (
          <p className="text-xs sm:text-sm italic mt-2 line-clamp-3 text-[#5a3d4c]" data-testid="gift-card-message">“{card.message}”</p>
        )}
        <div className="mt-auto">
          {card.buyer_name && <div className="text-[11px]">Con affetto, {card.buyer_name}</div>}
          <div className={`mt-2 inline-block px-3 py-1.5 rounded-xl bg-white/80 font-mono whitespace-nowrap ${compact ? "text-xs tracking-[0.15em]" : "text-base sm:text-lg tracking-[0.2em]"}`} data-testid="gift-card-code">
            {card.code || "EPIC-XXXX-XXXX"}
          </div>
          <div className="text-[9px] uppercase tracking-widest mt-1.5 text-[#7d5068]">
            {card.sede_name ? `Valida a ${card.sede_name}` : ""}{card.expires_at ? ` · riscatta entro il ${fmtDate(card.expires_at)}` : " · valida 6 mesi"}
          </div>
        </div>
      </div>
    </div>
  );
});
